import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideAppInitializer, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';

import { routes } from './app.routes';
import { AuthService, ClientLogService, CommonCheckService, EnvironmentService, FoxxylibSwaggerGenInterceptor, GuiService, StepforwardService } from 'FoxxyLib';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideStore, StoreModule } from '@ngrx/store';
import { reduceUser } from './store/user/reducer';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { EffectsModule, provideEffects } from '@ngrx/effects';
import { UserEffects } from './store/user/effect';
import { featureNotifictaionName, NotificationsEffects, reducerNotification } from './store/notifications/store';
import { CommonModule, DecimalPipe } from '@angular/common';
import { reduceNavigation } from '../shell/store/reducer';
import { TranslateModule } from '@ngx-translate/core';
import { SignalMessageService } from './services/common/signalmessage.service';
import { IsAuthenticatedGuardSort } from '@sortapp/guards/is-authenticated.guard';
import { providePrimeNG } from 'primeng/config';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import Sortimentierenpreset from '@sortapp/SortPreset';
import { MessageService } from 'primeng/api';
import { SortimentStringPipe } from './sortimentieren/pipes/StringPipe';
import { SortRouteReuseStrategy } from './classess/sort-reuse-strategy';
import { intializeApp } from './app-init';
import { navigationfeatureName } from '@sortapp/shell/store';




export const appConfig: ApplicationConfig = {


  providers: [
    provideAppInitializer(() => intializeApp()),
    provideZonelessChangeDetection(), // see also https://angularexperts.io/blog/zoneless-angular
    DecimalPipe, SortimentStringPipe,

    provideRouter(routes),
    {
      provide: RouteReuseStrategy,
      useClass: SortRouteReuseStrategy,
    },

    CommonModule, AuthService,
    GuiService,

    StepforwardService,
    CommonCheckService, EnvironmentService, SignalMessageService, ClientLogService, IsAuthenticatedGuardSort,
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Sortimentierenpreset,
        options: {
          darkModeSelector: '.sort-dark-mode',
        }
      }
    }),

    MessageService,
    { provide: LOCALE_ID, useValue: 'de-DE' },
    provideOAuthClient(),
    provideHttpClient(),
    provideStore({ user: reduceUser, navigation: reduceNavigation, notificationsFeature: reducerNotification }),
    provideEffects([NotificationsEffects, UserEffects]),
    provideStoreDevtools(),
    { provide: HTTP_INTERCEPTORS, useClass: FoxxylibSwaggerGenInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      // Store mit provideStore !!!!
      StoreModule.forRoot({}),
      EffectsModule.forRoot(),
      EffectsModule.forRoot([UserEffects, NotificationsEffects]),
      StoreModule.forFeature(featureNotifictaionName, reducerNotification),
      StoreModule.forFeature(navigationfeatureName, reduceNavigation),
      EffectsModule.forFeature([NotificationsEffects]),
      TranslateModule.forRoot({
        defaultLanguage: 'de'
      })


    )

  ]
};
